import { Button, Checkbox, Dropdown, Field, Input, Option, Textarea } from '@fluentui/react-components';
import { useMemo, useState } from 'react';
import type { Client } from '../../../models/Client';
import { ClientStatus, ClientTag } from '../../../models/enums';
import { validateEmail, validateRequired, validateVatNumber } from '../../../utils/validation';
import { ClientTags } from './ClientTags';

const statusOptions = [
  { label: 'Active', value: ClientStatus.Actif },
  { label: 'Suspended', value: ClientStatus.Suspendu },
  { label: 'Inactive', value: ClientStatus.Inactif },
  { label: 'Trial', value: ClientStatus.EnPeriodeTrial },
];

export const ClientForm = ({ initialValue, onSubmit, submitLabel = 'Save' }: { initialValue?: Partial<Client>; onSubmit: (payload: Omit<Client, 'cr_crm_clientid'>) => void; submitLabel?: string }) => {
  const [form, setForm] = useState({
    cr_crm_companyname: initialValue?.cr_crm_companyname ?? '',
    cr_crm_partnercentercustomerid: initialValue?.cr_crm_partnercentercustomerid ?? '',
    cr_crm_domain: initialValue?.cr_crm_domain ?? '',
    cr_crm_email: initialValue?.cr_crm_email ?? '',
    cr_crm_phone: initialValue?.cr_crm_phone ?? '',
    cr_crm_vatexempt: initialValue?.cr_crm_vatexempt ?? false,
    cr_crm_vatnumber: initialValue?.cr_crm_vatnumber ?? '',
    cr_crm_tags: initialValue?.cr_crm_tags ?? ([] as ClientTag[]),
    cr_crm_notes: initialValue?.cr_crm_notes ?? '',
    cr_crm_status: initialValue?.cr_crm_status ?? ClientStatus.Actif,
    cr_crm_lastsyncat: initialValue?.cr_crm_lastsyncat,
    cr_crm_syncerror: initialValue?.cr_crm_syncerror,
    createdon: initialValue?.createdon,
    modifiedon: initialValue?.modifiedon,
    ownerid: initialValue?.ownerid,
  });

  const validation = useMemo(() => validateRequired(form.cr_crm_companyname, 'Company name') ?? validateEmail(form.cr_crm_email) ?? validateVatNumber(form.cr_crm_vatnumber), [form]);

  return (
    <div style={{ display: 'grid', gap: 12 }}>
      <Field label="Company name" validationMessage={validation ?? undefined}><Input value={form.cr_crm_companyname} onChange={(_, data) => setForm((current) => ({ ...current, cr_crm_companyname: data.value }))} /></Field>
      <Field label="Partner Center customer id"><Input value={form.cr_crm_partnercentercustomerid} onChange={(_, data) => setForm((current) => ({ ...current, cr_crm_partnercentercustomerid: data.value }))} /></Field>
      <Field label="Domain"><Input value={form.cr_crm_domain} onChange={(_, data) => setForm((current) => ({ ...current, cr_crm_domain: data.value }))} /></Field>
      <Field label="Email"><Input value={form.cr_crm_email} onChange={(_, data) => setForm((current) => ({ ...current, cr_crm_email: data.value }))} /></Field>
      <Field label="Phone"><Input value={form.cr_crm_phone} onChange={(_, data) => setForm((current) => ({ ...current, cr_crm_phone: data.value }))} /></Field>
      <Field label="Status"><Dropdown selectedOptions={[String(form.cr_crm_status)]} value={statusOptions.find((item) => item.value === form.cr_crm_status)?.label} onOptionSelect={(_, data) => setForm((current) => ({ ...current, cr_crm_status: Number(data.optionValue) as ClientStatus }))}>{statusOptions.map((item) => <Option key={item.value} value={String(item.value)}>{item.label}</Option>)}</Dropdown></Field>
      <Checkbox label="VAT exempt" checked={form.cr_crm_vatexempt} onChange={(_, data) => setForm((current) => ({ ...current, cr_crm_vatexempt: Boolean(data.checked) }))} />
      <Field label="VAT number"><Input value={form.cr_crm_vatnumber} onChange={(_, data) => setForm((current) => ({ ...current, cr_crm_vatnumber: data.value }))} /></Field>
      <ClientTags value={form.cr_crm_tags} onChange={(tags) => setForm((current) => ({ ...current, cr_crm_tags: tags }))} />
      <Field label="Notes"><Textarea value={form.cr_crm_notes} onChange={(_, data) => setForm((current) => ({ ...current, cr_crm_notes: data.value }))} rows={4} /></Field>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <Button appearance="primary" disabled={Boolean(validation)} onClick={() => onSubmit(form)}>{submitLabel}</Button>
      </div>
    </div>
  );
};
